import React from "react";

const Heatmap = ({ days }) => {
  const today = new Date();
  const oneDayMillis = 24 * 60 * 60 * 1000; // Milliseconds in one day

  const lastXDays = Array.from({ length: 20 }, (_, i) => {
    const date = new Date(today.getTime() - i * oneDayMillis);
    return date.setHours(0, 0, 0, 0);
  }).reverse();

  const completionsPerDay = lastXDays.map(
    (day) =>
      days.filter((d) => {
        const completionDate = new Date(d).setHours(0, 0, 0, 0);
        return completionDate === day;
      }).length,
  );

  return (
    <div className="flex flex-wrap w-full">
      {completionsPerDay.map((completions, index) => {
        const color = completions === 0 ? "bg-gray-200" : `bg-green-400`; // TailwindCSS doesn't support dynamic class names, adjust accordingly
        return (
          <div
            key={index}
            title={`Completions: ${completions}`}
            className={`${color} w-2 h-2 mr-1`}
          ></div>
        );
      })}
    </div>
  );
};

export default Heatmap;
